import { render } from "./material_selection.vue?vue&type=template&id=47f42b73"
import script from "./material_selection.vue?vue&type=script&lang=js"
export * from "./material_selection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Site résa/reservation.ogalo-saumurvaldeloire.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__